import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from 'utils/axios'

export const fetchMatchHighlights = (matchUuid, params) => {
  const url = `/v2/matches/${matchUuid}/match-highlights`

  return getRequest(url, { params })
}

export const createMatchHighlight = (matchUuid, data) => {
  const url = `/v2/matches/${matchUuid}/match-highlights`

  return postRequest(url, data)
}

export const updateMatchHighlight = (matchHighlightUuid, data) => {
  const url = `/v2/match-highlights/${matchHighlightUuid}`

  return patchRequest(url, data)
}

export const deleteMatchHighlight = (matchHighlightUuid) => {
  const url = `/v2/match-highlights/${matchHighlightUuid}`

  return deleteRequest(url)
}
